<!-- @format -->
<div
	[ngClass]="backdropColor"
	[id]="addlData.widgetTypeTag">
	<section
		class="home hmf-display-flex hmf-flex-row hmf-flex-wrap hmf-justify-content-sm-center ie-height"
		[ngClass]="{
			'hmf-mt-l hmf-mt-m-xxl': !data[0].textBoxPosition && addlData.tagSectionNum === '1'
		}">
		<div
			[id]="datum.title || datum.headline | dcsgStripSpecialChars: '\ |\'|\′|\&|\-'"
			class="{{ setTextAlignment }}"
			[ngClass]="componentContainer"
			*ngFor="let datum of data; let i = index">
			<a
				*ngIf="datum.link"
				class="hmf-display-block hmf-position-relative"
				[ngClass]="{ 'inline-image-styling': isInline }"
				[class.hmf-mb-xxs]="!isInline"
				[href]="datum.link"
				[title]="datum.headline || datum.title"
				[attr.target]="targetService(datum.link)"
				[attr.data-em]="
					createTag(
						inputPosition ? inputPosition : i + 1,
						1,
						'',
						datum.headline || datum.title
					)
				">
				<ng-template [ngTemplateOutlet]="componentImage"></ng-template>
			</a>
			<div
				*ngIf="!datum.link"
				class="hmf-display-block hmf-position-relative w-100"
				[ngClass]="{ 'inline-image-styling': isInline }"
				[class.hmf-mb-xxs]="!isInline">
				<ng-template [ngTemplateOutlet]="componentImage"></ng-template>
			</div>
			<div
				class="hmf-display-flex hmf-px-xxs hmf-py-xxs hmf-flex-column"
				[ngClass]="copyboxClasses"
				[sharedUtilsDirectiveAppNoBackground]="datum.textBlockBackground"
				[textColor]="datum.textColor"
				*ngIf="datum.textBoxPosition !== 'none'">
				<engage-badge
					*ngIf="datum.badge && (datum.badge[0] | keyvalue)?.length"
					[data]="datum.badge"
					[ngClass]="badgeStyling">
				</engage-badge>
				<a
					*ngIf="datum.link"
					[href]="datum.link"
					[title]="datum.headline || datum.title"
					[attr.target]="targetService(datum.link)"
					[attr.data-em]="
						createTag(
							inputPosition ? inputPosition : i + 1,
							1,
							'',
							datum.headline || datum.title
						)
					">
					<ng-template [ngTemplateOutlet]="componentText"></ng-template>
				</a>
				<ng-container *ngIf="!datum.link">
					<ng-template [ngTemplateOutlet]="componentText"></ng-template>
				</ng-container>
				<ng-container *ngIf="datum.emailSignUp">
					<engage-email-signup [data]="datum"></engage-email-signup>
				</ng-container>
				<home-wysiwyg
					*ngIf="datum.informationalsContent"
					[data]="[datum.informationalsContent[0]]"
					[addlData]="[datum.title]">
				</home-wysiwyg>
				<div
					class="text ctas hmf-display-flex hmf-flex-column hmf-align-items-center hmf-flex-m-row hmf-flex-m-wrap"
					[ngClass]="buttonContainer">
					<ng-container *ngIf="datum?.cta && datum?.quickviewCta; else singleCtas">
						<div
							*ngFor="let item of datum.cta; let j = index"
							class="hmf-display-flex hmf-justify-content-center hmf-flex-wrap"
							[ngClass]="buttonStyling">
							<ng-container
								*ngIf="showButton() && (item | keyvalue)?.length && !item.ctaText">
								<a
									hmf-button
									height="base"
									[variant]="buttonVariant"
									[href]="item.link"
									[attr.altText]="item.linkTitle"
									[dataEm]="
										createTag(
											inputPosition ? inputPosition : i + 1,
											j + 1,
											item.linkTitle,
											datum.headline || datum.title
										)
									"
									[attr.target]="targetService(item.link)"
									[attr.aria-label]="datum.title"
									[text]="cta.linkTitle"></a>
							</ng-container>
							<home-cta
								*ngIf="
									!showButton() &&
									(item | keyvalue)?.length &&
									item.link?.length &&
									item.linkTitle?.length
								"
								[data]="item"
								[addlData]="addlData"
								[parentIndex]="inputPosition ? inputPosition : i + 1"
								[ctaIndex]="j + 1"
								[altText]="datum.headline || datum.title"
								class="hmf-py-s hmf-m-mb-m"></home-cta>
							<home-quickview-cta
								*ngIf="item.ecode?.length && item.ctaText?.length && !item.link"
								[data]="item"
								[addlData]="addlData"></home-quickview-cta>
						</div>
					</ng-container>
					<ng-template #singleCtas>
						<ng-container *ngIf="datum?.cta">
							<div
								*ngFor="let cta of datum.cta; let j = index"
								class="hmf-display-flex hmf-justify-content-center hmf-flex-wrap"
								[ngClass]="buttonStyling">
								<ng-container *ngIf="showButton() && (cta | keyvalue)?.length">
									<a
										hmf-button
										height="base"
										[variant]="buttonVariant"
										[href]="cta.link"
										[attr.altText]="cta.linkTitle"
										[dataEm]="
											createTag(
												inputPosition ? inputPosition : i + 1,
												j + 1,
												cta.linkTitle,
												datum.headline || datum.title
											)
										"
										[attr.target]="targetService(cta.link)"
										[attr.aria-label]="datum.title"
										[text]="cta.linkTitle"></a>
								</ng-container>
								<ng-container *ngIf="!showButton() && (cta | keyvalue)?.length">
									<home-cta
										[data]="cta"
										[addlData]="addlData"
										[parentIndex]="inputPosition ? inputPosition : i + 1"
										[ctaIndex]="j + 1"
										[altText]="datum.headline || datum.title"
										class="hmf-py-s hmf-m-mb-m">
									</home-cta>
								</ng-container>
							</div>
						</ng-container>
						<ng-container *ngIf="datum?.quickviewCta">
							<div
								*ngFor="let item of datum.quickviewCta"
								class="hmf-display-flex hmf-justify-content-center hmf-flex-wrap"
								[ngClass]="buttonStyling">
								<home-quickview-cta
									[data]="item"
									[addlData]="addlData"></home-quickview-cta>
							</div>
						</ng-container>
					</ng-template>
				</div>
				<div *ngIf="datum.pricedPackage">
					<home-priced-package
						[packagePrice]="datum.pricedPackage[0].packagePrice"
						[purchasedSeperately]="
							datum.pricedPackage[0].purchasedSeperately
						"></home-priced-package>
				</div>
			</div>
			<ng-template #componentText>
				<div [ngClass]="{ 'hmf-py-s hmf-py-m-0': isInline }">
					<ng-container *ngIf="datum.textBoxPosition && datum.headline">
						<p class="text text--copyboxTitle hmf-mb-xxs">{{ datum.headline }}</p>
					</ng-container>
					<p
						*ngIf="(!datum.textBoxPosition && datum.headline) || datum.title"
						[ngStyle]="{ color: isGGStaticPage ? ggStaticColors.primary : '' }"
						class="text text--title hmf-mb-xxxs">
						{{ datum.headline || datum.title }}
					</p>
					<p
						*ngIf="datum.subCopy"
						class="hmf-subheader-bold-l"
						[ngStyle]="{ color: isGGStaticPage ? ggStaticColors.secondary : '' }">
						{{ datum.subCopy }}
					</p>
					<p
						*ngIf="datum.description"
						class="text text--subtext hmf-my-xxs"
						[ngStyle]="{ color: isGGStaticPage ? ggStaticColors.secondary : '' }">
						{{ datum.description }}
						<a
							*ngIf="datum.optionalDetailsLink"
							class="details-color"
							[href]="datum.optionalDetailsLink"
							[title]="datum.description"
							[attr.data-em]="
								createTag(
									inputPosition ? inputPosition : i + 1,
									1,
									'',
									datum.description
								)
							">
							Details
						</a>
					</p>
				</div>
			</ng-template>
			<ng-template #componentImage>
				<shared-media-component-media
					*ngIf="datum.image || datum.visualAssets"
					[visualAssets]="datum.visualAssets"
					[imageWidthParam]="setWidthParamForImage()"
					[altText]="datum.altText"
					[image]="datum.image"
					[mobileImg]="datum.mobileImg"
					[itemTitle]="datum.title ? datum.title : datum.headline"
					[youtubeId]="datum.youtubeId"
					[animation]="datum.animation"
					[willLazyLoad]="willLazyLoad"
					[imagePagePosition]="addlData.tagSectionNum"></shared-media-component-media>
			</ng-template>
		</div>
	</section>
	<section
		*ngIf="data[0].informationalsContent"
		class="home hmf-display-flex hmf-flex-row hmf-flex-wrap hmf-justify-content-sm-center ie-height"
		[ngClass]="{
			'hmf-mt-l hmf-mt-m-xxl': !data[0].textBoxPosition && addlData.tagSectionNum === '1'
		}">
		<ng-container *ngFor="let datum of data; let i = index"></ng-container>
	</section>
</div>
